// extracted by mini-css-extract-plugin
export default {"partnerMainColor":"--partner-main-color","partnerSecondaryColor":"--partner-secondary-color"};